import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import './styles.css'

function CookieNotice({ hideCookieNotice }) {
  return (
    <div className="cookie-notice">
      <p className="cookie-notice__message">
        This website uses cookies. See our{' '}
        <Link to="/customer-care/privacy-policy/">Privacy Policy</Link>.
      </p>
      <button
        type="button"
        className="cookie-notice__cta btn -thin -blue-2"
        onClick={() => hideCookieNotice()}
      >
        Accept
      </button>
    </div>
  )
}

CookieNotice.propTypes = {
  hideCookieNotice: PropTypes.func.isRequired
}

export default CookieNotice
